import styled from '@emotion/styled'
import { Button, Grid, Paper, Stack } from '@mui/material'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useActiveElements } from '../../../hooks/useActiveElements'
import { useCustomForm } from '../../../hooks/useCustomForm'
import { useOpenComponent } from '../../../hooks/useOpenComponent'
import {  setQuantityLiters, setSubTotalEstacionario } from '../../../slices/orderSlice'
import { customStyles } from '../../../styles'
import { animations } from '../../../utils/animations'
import {  MainButton, MainInput,  } from '../../helpers'

const byPrice = [
  {
    id: 500,
  },
  {
    id: 700,
  },
  {
    id: 1000,
  },
  {
    id: 1500,
  },
  {
    id: 'Otro',
  },
]
const byLiter = [
  {
    id: 50,
  },
  {
    id: 70,
  },
  {
    id: 100,
  },
  {
    id: 150,
  },
  {
    id: 'Otro',
  },
]

export const QtEstacionario = (props) => {
  const Item = styled(Button)(({ theme }) => ({
    width: '100%',
    height: 100,
    borderRadius: 0,
    position: 'relative',
    overflow: 'hidden',
    fontSize: customStyles.fontSize.regular,
    
 }))


  const { isByCost } = useSelector(state => state.order)
  const [handleNewData, setHandleNewData] = useState(byPrice)
  const { activeData, handleActive } = useActiveElements( handleNewData )
  const dispatch = useDispatch()
  const { fadeIn } = animations
  const {inputValues, handleOnChange, updateForm} = useCustomForm({ customAmount: '' })
  const { customAmount } = inputValues
  const { isOpen, handleIsOpen, handleOpenControlled } = useOpenComponent()
 
  const handleQT = (qt) => {
    handleActive(qt)
    dispatch(setQuantityLiters({isByCost, qt}))
    dispatch(setSubTotalEstacionario(qt))
    handleOpenControlled(false)
  }
  
  const handleCustomAmount = (amount, confirm) => {
    handleActive(amount)
    dispatch(setQuantityLiters({isByCost, qt:amount}))
    dispatch(setSubTotalEstacionario(amount))
    confirm && amount > 0 && handleIsOpen()
  }

  const handleCancel = () => {
    updateForm({
      customAmount:0
    })
    handleIsOpen()
  }
  useEffect(() => {
    handleOpenControlled(false)
  }, [])
  useEffect(() => {
    isByCost ? setHandleNewData( byPrice ) : setHandleNewData( byLiter )
  }, [isByCost])

  useEffect(() => {
    isOpen && handleCustomAmount(parseInt(customAmount))
  }, [customAmount])

  return (
    <>
    <Grid container spacing={1} mt={10}>
      {
        activeData.map(item => (
          <Grid item xs={ item.id === 'Otro' ? 12 : 6 } key={item.id}>
            {
              item.id === 'Otro' && isOpen
              ? 
              <Stack spacing={3} className={fadeIn}>
                <MainInput name="customAmount" value={customAmount} onChange={handleOnChange} placeholder="Ingrese la cantidad" type="number" 
                // sx={  }}
                sx2={{fontSize: customStyles.fontSize.large}}
                inputProps={{textAlign: 'center'}}
                height={100}
                className={fadeIn}
                />
                <Stack direction="row" spacing={2} justifyContent="center">
                  <MainButton text="CANCELAR" variant="outlined" onClick={handleCancel}/>
                  <MainButton text="ACEPTAR" variant="contained" onClick={() => handleCustomAmount(parseInt(customAmount), true)}/>
                </Stack>
              </Stack>
              : <Paper className={fadeIn} sx={{transition: 'ease .2s',
              '&:active': {
                transform: 'scale(.97)'
              }}}>
                <Item onClick={ item.id === 'Otro' ? handleIsOpen : () => handleQT(item.id)} variant={ item.active ? 'contained' : '' }>
                  { isByCost && '$' } {item.id} { !isByCost && item.id !== 'Otro' && 'lt' }
                 
                </Item>
              </Paper>
            }
          </Grid>
        ))
      }

    </Grid>
</>
  )
}
